module.exports = __webpack_public_path__ + "p4_img1.jpg?20f48c0232e8a022f507f86102f78dd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img1.jpg
// module id = 112
// module chunks = 0